import { cx } from './cx.js';

/**
 * Plaque d'immatriculation : l'identifiant que l'atelier cherche des yeux. Fond blanc, filet,
 * bande européenne à gauche, caractères à chasse fixe. Le texte reste un seul nœud (recherche,
 * lecteurs d'écran).
 */
export function Plate({
  plate,
  size = 'md',
  className,
}: {
  plate: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  return (
    <span
      className={cx(
        'inline-flex shrink-0 items-stretch overflow-hidden rounded-md bg-plate align-middle ring-1 ring-plate-line ring-inset shadow-xs',
        className,
      )}
    >
      <span
        aria-hidden
        className={cx('shrink-0 bg-plate-band', { sm: 'w-1.5', md: 'w-2', lg: 'w-2.5' }[size])}
      />
      <span
        className={cx(
          'font-mono font-semibold tracking-[0.06em] whitespace-nowrap text-plate-ink uppercase tabular-nums',
          {
            sm: 'px-1.5 py-px text-sm',
            md: 'px-2 py-0.5 text-base',
            lg: 'px-2.5 py-0.5 text-xl lg:text-2xl',
          }[size],
        )}
      >
        {plate}
      </span>
    </span>
  );
}
